export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',
    uiSetError: '[UI] Set Error Msg',
    uiRemoveError: '[UI] Remove Error Msg',
    uiStartLoading: '[UI] Start Loading',
    uiFinishLoading: '[UI] Finish Loading',
    uiParameters: '[UI] Parameters',
}